import { Button, Row, Col, Container } from 'reactstrap';
import {
  useTranslator,
  callNativeAppRemoveLastRoute,
  useAppContext,
} from '@front-activerse/common-components';
import { useNavigate } from 'react-router-dom';
import Layout from '../Layout/Layout';

const Error404 = () => {
  const navigate = useNavigate();

  const {
    images: { error404Img },
  } = useAppContext();

  const { t } = useTranslator();

  return (
    <Layout>
      <div className="page-template-error">
        <section className="text-center d-flex align-items-center full-height">
          <Container>
            <Row>
              <Col md={{ size: 4, offset: 4 }}>
                <img
                  src={error404Img}
                  className="img-fluid mb-xl"
                  width="343"
                  height="250"
                  alt=""
                />
                <h2 className="title-medium semi-bold">{t('page404.title')}</h2>
                <p className="mb-xl text-text-variant-color">{t('page404.content')}</p>
                <Button
                  color="primary"
                  className="w-100"
                  onClick={() => {
                    navigate(-1);
                    callNativeAppRemoveLastRoute();
                  }}
                >
                  {t('page404.back.button')}
                </Button>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </Layout>
  );
};

export default Error404;
